import { NFTAddress, NFTMarketAddress } from "../constants";

import NFTMarketAbi from "../contracts/NFTMarket.sol/NFTMarket.json";

export function MarketContract(kit) {
  try {
    const Market = new kit.web3.eth.Contract(
      NFTMarketAbi.abi,
      NFTMarketAddress
    );
    return Market;
  } catch (err) {
    console.log(err);
  }
}

export async function listToken(performActions, tokenId, price, address) {
  try {
    performActions(async (kit) => {
      const Market = MarketContract(kit);
      const tx = await Market.methods
        .listToken(NFTAddress, tokenId, kit.web3.utils.toWei(price, "ether"))
        .send({ from: address });
      return await tx;
    });
  } catch (err) {
    console.log(err);
  }
}

export async function buyToken(performActions, listingId, address, price) {
  try {
    performActions(async (kit) => {
      const Market = MarketContract(kit);
      const tx = await Market.methods
        .buyToken(NFTAddress, listingId)
        .send({ from: address, value: price });
      return await tx;
    });
  } catch (err) {
    console.log(err);
  }
}

export async function fetchListings(kit) {
  try {
    const Market = MarketContract(kit);

    const res = await Market.methods.getAllListings().call();
    return res;
  } catch (err) {
    console.log(err);
  }
}
